// extracted by mini-css-extract-plugin
export default {"simpleSearchWrapper":"Search_simpleSearchWrapper__uxyL+","searchInputWrapper":"Search_searchInputWrapper__9FHNu","inputTextWrapper":"Search_inputTextWrapper__syEv6"};